import {handledGroupFinTerm} from "../../../../../../../../components/composed/GroupFinTermBlock/defProps";

export const GroupFinTermCardDefProps = {
  handledGroupFinTerm: handledGroupFinTerm
};